import {
  getMemoAttributionDate,
  getMemoAttributionText,
} from '../MemoDetails/utils/memoAttribution';
import { MemosTable_MemoFragment } from './graphql/MemosTable.generated';
import { MemosTableRowData } from './MemosTable.types';

export function mapMemoToRowData(
  memo: MemosTable_MemoFragment
): MemosTableRowData {
  const attributionParams = {
    createdAt: memo.createdAt,
    updatedAt: memo.updatedAt,
    entryMode: memo.entryMode,
    updateUserDisplayName: memo.updateUser.displayName,
  };

  return {
    id: memo.id,
    createdAt: memo.createdAt,
    updatedAt: memo.updatedAt,
    name: memo.name,
    memoPromptType: memo.memoPrompt?.memoPromptType ?? null,
    status: getMemoAttributionText(attributionParams),
    statusDate: getMemoAttributionDate(attributionParams),
    statusLabel: getMemoAttributionText({
      ...attributionParams,
      includeDate: false,
    }),
    userDisplayName: memo.user.displayName,
  };
}
